import { createPortal } from 'react-dom';
import { useMessage } from '../hooks';
import { MessagePositions } from './molecules/MessagePositions';

/**
 * Componente que renderiza todos los toasts en un portal
 * @example
 * <Toaster />
 */
export const Toaster = () => {
  const { messagesByPosition } = useMessage();
  return createPortal(<MessagePositions messages={messagesByPosition} />, document.body);
};
